import { DataHookOptions, useDataList, useDataRead } from '@hooks/data'
import { Booking } from 'types/model/booking'
import { bookingApi } from './api'
import { BookingTicket } from 'types/model/ticket'
import { useCallback } from 'react'

export function useBooking(id?: string | null, options?: DataHookOptions<Booking>) {
  const { mutate, ...swrResponse } = useDataRead<Booking>(
    bookingApi,
    !id ? null : `/booking/${id}`,
    options
  )

  const update = useCallback(
    async (val: Partial<Booking>) => {
      if (!id) throw new Error('No ID to update booking')
      const response = await bookingApi.update(id, val)
      await mutate(response)
    },
    [id, mutate]
  )

  return { ...swrResponse, mutate, update }
}

export function useBookingTickets(
  id?: string | null,
  options?: DataHookOptions<BookingTicket[]> & {
    params?: {
      ticketToken?: string
    }
  }
) {
  return useDataList<BookingTicket>(bookingApi, !id ? null : `/booking/${id}/ticket`, options)
}
